import { createVanIconComponent } from "./van"

const UnderwayOutlined = createVanIconComponent("underway-o")
export default UnderwayOutlined
